/**
 * Represents a comment.
 */
var Comment = /** @class */ (function () {
    function Comment(id, commentProperties, text) {
        this.id = id;
        this.commentProperties = commentProperties;
        this.text = text;
    }
    return Comment;
}());
export { Comment };
